<template>
  <!-- Main Content -->
  <v-card class="mx-auto" width="100%">
    <!-- Left Navigation -->
    <left-navigation
      ref="left-navigation"
      v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
    ></left-navigation>

    <!-- Top App Bar -->
    <top-navigation ref="top-navigation"></top-navigation>

    <!-- Contents -->
    <v-main>
      <v-container class="fill-height pa-0" fluid>
        <v-row no-gutters class="layout-cols-row">
          <!-- Left rail -->
          <v-col
            md="3"
            class="layout-cols layout-nav"
            v-if="$vuetify.breakpoint.mdAndUp || navMenuOpen"
          >
            <customers-left-rail
              ref="customers-left-rail"
            ></customers-left-rail>
          </v-col>
          <!-- Center rail -->
          <v-col
            cols="12"
            md="6"
            class="layout-cols"
            v-if="
              $vuetify.breakpoint.mdAndUp ||
                (!navMenuOpen && !showCustomerDetail)
            "
          >
            <history-center-rail
              ref="history-center-rail"
            ></history-center-rail>
          </v-col>
          <!-- Right rail -->
          <v-col
            cols="12"
            md="3"
            class="layout-cols"
            v-if="
              $vuetify.breakpoint.mdAndUp ||
                (!navMenuOpen && showCustomerDetail)
            "
          >
            <customer-right-rail
              ref="customer-right-rail"
            ></customer-right-rail>
          </v-col>
          <!-- <div>TODO BOTTOM BUTTONS TO Switch between history and detail</div> -->
        </v-row>
      </v-container>
    </v-main>
  </v-card>
</template>

<script>
const TopNavigation = () =>
  import(
    /* webpackChunkName: "components-global-TopNavigation" */ `../components/global/TopNavigation.vue`
  );
const LeftNavigation = () =>
  import(
    /* webpackChunkName: "components-global-LeftNavigation" */ `../components/global/LeftNavigation.vue`
  );
const HistoryCenterRail = () =>
  import(
    /* webpackChunkName: "components-customers-HistoryCenterRail" */ `../components/customers/HistoryCenterRail.vue`
  );
const CustomersLeftRail = () =>
  import(
    /* webpackChunkName: "components-customers-CustomersLeftRail" */ `../components/customers/CustomersLeftRail.vue`
  );
const CustomerRightRail = () =>
  import(
    /* webpackChunkName: "components-customers-CustomerRightRail" */ `../components/customers/CustomerRightRail.vue`
  );

export default {
  components: {
    TopNavigation,
    LeftNavigation,
    HistoryCenterRail,
    CustomersLeftRail,
    CustomerRightRail
  },
  data() {
    return {};
  },
  computed: {
    showCustomerDetail() {
      return this.$store.getters["entities/settings/query"]().first()
        .showCustomerDetail;
    },
    navMenuOpen() {
      return (
        this.$root.$children[0].navMenuOpen || this.currentCustomer == null
      );
    },
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    currentCustomer() {
      let vueThis = this;
      if (vueThis.user && vueThis.user.currentCustomerId) {
        return vueThis.$store.getters["entities/customers/query"]()
          .withAllRecursive(2)
          .find(vueThis.user.currentCustomerId);
      } else if (vueThis.customerId > 0) {
        return vueThis.$store.getters["entities/customers/query"]()
          .withAllRecursive(2)
          .find(vueThis.customerId);
      } else {
        return null;
      }
    }
  },
  created() {},
  methods: {},
  watch: {}
};
</script>
<style scoped lang="stylus"></style>
